import { ComponentPortal } from '@angular/cdk/portal';
import { inject, Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class FloatingPanelService {
  // Current portal being displayed
  readonly portal$: Observable<ComponentPortal<any> | null>;
  // Emits when the portal should be closed
  readonly close$: Observable<void>;

  private activePortal$: BehaviorSubject<ComponentPortal<any> | null>;
  private closePortal$: Subject<void>;
  private portalComponent: ClassType<any> | null;
  private injector = inject(Injector);

  constructor() {
    this.activePortal$ = new BehaviorSubject<ComponentPortal<any> | null>(null);
    this.closePortal$ = new Subject<void>();
    this.portalComponent = null;
    this.portal$ = this.activePortal$.asObservable();
    this.close$ = this.closePortal$.asObservable();
  }

  open(portal: ClassType<any>) {
    this.close();
    this.portalComponent = portal;
    this.activePortal$.next(new ComponentPortal(portal, null, this.injector));
  }

  close() {
    this.portalComponent = null;
    this.activePortal$.next(null);
    this.closePortal$.next();
  }

  isOpen(portal: ClassType<any>) {
    return this.portalComponent?.name === portal.name;
  }

  isOpen$(portal: ClassType<any>) {
    return this.activePortal$.pipe(
      map((p) => p?.component.name === portal.name),
    );
  }
}
